<template>
  <div class="otherMaintenance">
    <my-head :title="title"/>

    <div class="auto-width otherMaintenance-box">
      <!-- <mu-card class="my-null" v-if="isNoTask">当前无任务</mu-card> -->

      <mu-text-field v-model="form.vin" @blur="" placeholder="搜索" ref="vin" class='input auto-width' @keyup.enter.native="getData()"><i class="iconfont icon-saomiao" @click="scan('vin')"></i></mu-text-field>
      
      <mu-card class="my-card" v-for="item in task">
        <mu-row @click="showDetailed(item)">
          <mu-col span="8"><div class="grid-cell">单号：{{item.code}}</div></mu-col>
          <mu-col span="4"><div class="grid-cell">{{item.status}}</div></mu-col>
          <mu-col span="12"><div class="grid-cell">VIN：{{item.vin}}</div></mu-col>
          <mu-col span="6"><div class="grid-cell">车型：{{item.carType}}</div></mu-col>
          <mu-col span="6"><div class="grid-cell">颜色：{{item.color}}</div></mu-col>
          <mu-col span="12"><div class="grid-cell">库位：{{item.location}}</div></mu-col>
          <mu-col span="12"><div class="grid-cell">领取任务日期：{{item.startDate}}</div></mu-col>
          <mu-col span="12"><div class="grid-cell">计划完成日期：{{item.planDate}}</div></mu-col>
        </mu-row>
      </mu-card>
    </div>

				
		

    <div class="maintenance-btn auto-width fixed">
      <mu-button color="primary" @click="receive('scan')">扫码领取</mu-button>
      <mu-button color="primary" @click="receive('receive')">领取任务</mu-button>
    </div>

    <mu-dialog width="360" transition="slide-bottom" :overlay="false" :append-body="false" fullscreen :open.sync="showDetailedDialog">
      <mu-appbar color="primary" title="保养明细">
        <mu-button slot="right" flat  @click="hideDetailed">关闭</mu-button>
      </mu-appbar>
      <div class="detailed">
        <mu-card class="my-card">
          <mu-row>
            <mu-col span="8"><div class="grid-cell">单号：{{detailed.code}}</div></mu-col>
            <mu-col span="4"><div class="grid-cell">{{detailed.status}}</div></mu-col>
            <mu-col span="12"><div class="grid-cell">VIN：{{detailed.vin}}</div></mu-col>
            <mu-col span="6"><div class="grid-cell">车型：{{detailed.carType}}</div></mu-col>
            <mu-col span="6"><div class="grid-cell">颜色：{{detailed.color}}</div></mu-col>
            <mu-col span="12"><div class="grid-cell">库位：{{detailed.location}}</div></mu-col>
            <mu-col span="12"><div class="grid-cell">领取任务日期：{{detailed.startDate}}</div></mu-col>
            <mu-col span="12"><div class="grid-cell">计划完成日期：{{detailed.planDate}}</div></mu-col>
          </mu-row>
        </mu-card>
        
        <mu-data-table :expand-row-index.sync="expandIndex" :columns="columns" @sort-change="handleSortChange" :auto-expand="false" @row-click="rowClick" :data="detailed.detail">
          <template slot="expand" slot-scope="prop">
            <!-- 备注 -->
            <div style="padding: 5px;" ><mu-text-field class="auto-width" v-model="prop.row.remarks" placeholder="状态正常时，无需填写" :disabled="prop.row.status == '正常'" multi-line :rows="3" :rows-max="3"></mu-text-field></div>
          </template>
          <template slot-scope="scope">
            <td><div class="project" @click="OpenDiaLog(scope.row.project)">{{scope.row.project}}</div></td>
            <td>
              <mu-select class="auto-width-s" v-if="comProjectNameA(scope.row.project) && scope.row.project !== '其他异常问题'" label="" v-model="scope.row.status" full-width @change="changeAbnormal($event, scope.$index)">
                <mu-option v-for="option,index in options" :key="option" :label="option" :value="option"></mu-option>
              </mu-select>
              <mu-select class="auto-width-s" v-if="comProjectNameB(scope.row.project) && scope.row.project !== '其他异常问题'" label="" v-model="scope.row.status" full-width @change="changeAbnormal($event, scope.$index)">
                <mu-option v-for="option,index in optionsFox" :key="option" :label="option" :value="option"></mu-option>
              </mu-select>
              <div v-if="scope.row.project == '其他异常问题'">
                <mu-text-field v-model="scope.row.remarks" multi-line :rows="4" full-width></mu-text-field>
              </div>
            </td>
            <td>
              <mu-row class="auto-width" v-if="scope.row.type == 'C'">
                <mu-col span="6">
                  <div class="grid-cell">
                    <mu-text-field class="auto-width-s sm" v-if="scope.row.type == 'C'" v-model="scope.row.LV" @focus="openSelector('lv',scope.row, 'LV', scope.$index)" placeholder="LV"></mu-text-field>
                  </div>
                </mu-col>
                <mu-col span="6">
                  <div class="grid-cell">
                    <mu-text-field class="auto-width-s sm" v-if="scope.row.type == 'C'" v-model="scope.row.HV" @focus="openSelector('hv',scope.row, 'HV', scope.$index)" placeholder="HV"></mu-text-field>
                  </div>
                </mu-col>
              </mu-row>
              
              
              <mu-row class="auto-width" v-if="scope.row.type == 'I'">
                <mu-col span="6">
                  <div class="grid-cell">
                    <mu-text-field class="auto-width-s sm" v-if="scope.row.type == 'I'" @focus="openSelector('ty',scope.row, 'leftFrontTireP', scope.$index)" v-model="scope.row.leftFrontTireP" placeholder="左前"></mu-text-field>
                  </div>
                </mu-col>
                <mu-col span="6">
                  <div class="grid-cell">
                    <mu-text-field class="auto-width-s sm" v-if="scope.row.type == 'I'" @focus="openSelector('ty',scope.row,'rightFrontTireP', scope.$index)" v-model="scope.row.rightFrontTireP" placeholder="右前"></mu-text-field>
                  </div>
                </mu-col>
                <mu-col span="6">
                  <div class="grid-cell">
                    <mu-text-field class="auto-width-s sm" v-if="scope.row.type == 'I'" @focus="openSelector('ty',scope.row,'leftRearTireP', scope.$index)" v-model="scope.row.leftRearTireP" placeholder="左后"></mu-text-field>
                  </div>
                </mu-col>
                <mu-col span="6">
                  <div class="grid-cell">
                    <mu-text-field class="auto-width-s sm" v-if="scope.row.type == 'I'" @focus="openSelector('ty',scope.row,'rightRearTireP', scope.$index)" v-model="scope.row.rightRearTireP" placeholder="右后"></mu-text-field>
                  </div>
                </mu-col>
              </mu-row>
            </td>
          </template>
        </mu-data-table>
        <div class="maintenance-btn">
          <mu-button color="primary" @click="saves('bc')">保存</mu-button>
          <mu-button color="primary" @click="saves('bywc')">保养完成</mu-button>
        </div>
      </div>
    </mu-dialog>
      
    <mu-dialog title="" width="360" :open.sync="openSimple">
      {{txt}}
    </mu-dialog>

    <mu-bottom-sheet :open.sync="selector">
      <div class="bottom-sheet-mine">
        <div @click="cancelValue">取消</div>
        <div @click="sureValue">确认</div>
      </div>
      <mu-slide-picker v-if="selector" :slots="slots" :visible-item-count="5" @change="selectValueChange" :values="val"></mu-slide-picker>
    </mu-bottom-sheet>

    <scanning v-if="isScanning" :mark="scanMark" v-on:childByValue="childByValue" v-on:closeing="closeing"/>
  </div>
</template>

<script>
let lv = {}
for(let i=0; i<=100; i+= 10){
  lv[i] = 0;
}
let hv = {}
for(let i=0; i<=50; i+= 1){
  hv[i] = 0;
}
let ty = {}
for(let i=0; i<=3.9; i+= 0.05){
  ty[i.toFixed(2).toString()] = 0;
}
console.log(lv, hv, ty);
// 低电压 0-100 80 10
// 高电压 0-50 25 1
// 胎压 0-3.9 3.5 0.01
import myHead from '@/components/header'
import api from "@/common/api"
import scanning from "@/components/scanning"
export default {
  name: 'pickcar',
  components: {
    myHead, scanning
  },
  data () {
    return {
      slots: [{
        width: '100%',
        textAlign: 'center',
        values: Object.keys(lv)
      }],
      val: ["80", "0"],
      lvSlots: [
        {
          width: '100%',
          textAlign: 'center',
          values: Object.keys(lv)
        }
      ],
      lv: ["80", "0"],
      hvSlots: [
        {
          width: '100%',
          textAlign: 'center',
          values: Object.keys(hv)
        }
      ],
      hv: ["25", "0"],
      tySlots: [
        {
          width: '100%',
          textAlign: 'center',
          values: Object.keys(ty)
        }
      ],
      ty: ["3.50", "0"],

      detailed: {},
      selector: false,
      isNoTask: true,
      title: "其他保养",
      scanMark: "",
      tableLoading: false,
      isScanning: false,
      openFullscreen: false,
      deleteIndex: null, // 删除第几张
      openAlert: false, // 删除图片层
      src: [], // 拍照的图片
      files: [], // 图片文件 base64
      showDetailedDialog: false,
      expandIndex: -1, // 当前选择行
      bigImg: null,
      otherTaskTo: false,
      openSimple: false,
      task: [],
      txt: '',
      form: {
        vin: "",
        orderNumber: "",
        checkbox: [],
        text: ""
      },
      options: ['正常', '异常'],
      optionsFox: ['完成', '未完成'],
      sort: {
        name: '',
        order: 'asc'
      },
      columns: [
        { title: '保养项', width: 130, name: 'name' },
        { title: '状态', name: 'calories', width: 135, align: 'left'},
        { title: '保养值', name: 'fat', width: 200, align: 'left'}
      ],
      requestOnce: true,
      list: [],
      valueRow: [],
      valueKey: "",
      valueIndex: -1
    }
  },
  methods: {
    comProjectNameA(name){
      if(name == "漆面（车衣）" || name == "发动机舱、车内饰" || name == "行驶档位换挡、仪表显示" || name == "检查电池电压" || name == "检查胎压" || name == "检查车身"){
        return true;
      }else{
        return false;
      }
    },
    comProjectNameB(name){
      if(name == "漆面（车衣）" || name == "发动机舱、车内饰" || name == "行驶档位换挡、仪表显示" || name == "检查电池电压" || name == "检查胎压" || name == "检查车身"){
        return false;
      }else{
        return true;
      }
      
    },
    cancelValue(){
      this.selector = false;
    },
    sureValue(){
      this.valueRow[this.valueKey] = this.val[0];
      this.CheckAbnormal();
      this.selector = false;
    },
    openSelector(type, row, key, index){
      this.selector = true;
      this.valueRow = row;
      this.valueKey = key;
      this.valueIndex = index;
      if(type == 'lv'){
        this.slots = this.lvSlots;
        this.val = this.lv;
      }else if(type == 'hv'){
        this.slots = this.hvSlots;
        this.val = this.hv;
      }else if(type == 'ty'){
        this.slots = this.tySlots;
        this.val = this.ty;
      }
      this.valueRow[this.valueKey] && (this.val = [this.valueRow[this.valueKey]+"", '0']);
    },
    selectValueChange (value, index) {
      this.val = [""+value, "0"];
      this.valueRow[this.valueKey] = value;
      this.CheckAbnormal();
    },
    CheckAbnormal(){
      console.log(this.valueRow, this.valueKey);
      let tys = ()=>{
        let array = ["leftFrontTireP", "rightFrontTireP", "leftRearTireP", "rightRearTireP"];
        for(let i in array){
          if(this.valueRow[array[i]]){
            parseFloat(this.valueRow[array[i]]) < 3.3 || parseFloat(this.valueRow[array[i]]) > 3.7 ? 
            array[i] = 'true' : array[i] = 'false';
          }else{
            array[i] = "NaN";
          }
        }
        if(array.indexOf('true') >= 0){
          return true;
        }else{
          return false;
        }
      }
      let dys = ()=>{
        let array = ["LV", "HV"];
        for(let i in array){
          if(this.valueRow[array[i]]){
            if(array[i] == "LV"){
              parseFloat(this.valueRow[array[i]]) < 100 ? array[i] = 'true' : array[i] = 'false'
            }else if(array[i] == "HV"){
              parseFloat(this.valueRow[array[i]]) < 10 ? array[i] = 'true' : array[i] = 'false'
            }
          }else{
            array[i] = "NaN";
          }
        }
        if(array.indexOf('true') >= 0){
          return true;
        }else{
          return false;
        }
      }
      let abnormal = dys() || tys();
      
      if(abnormal){
        this.valueRow.status = "异常";
        this.expandIndex = this.valueIndex;
      }else{
        this.valueRow.status = "正常";
        this.expandIndex = -1;
      }
    },
    OpenDiaLog(msg){
      this.txt = msg;
      this.openSimple = true;
    },
    saves(type){
      let txt = type == 'bc' ? '保存' : '保养'
      this.Toast.loading({message: txt+'中'});
      let data = Object.assign({},this.$store.state.user,{
        content: {
          type: type,
          task: this.detailed
        }
      });
      /* 发送post请求 */
      if(this.requestOnce){
        this.requestOnce = false;
        this.common.reqData(api.app('maintenanceSaveOther'), data, res=>{
          this.requestOnce = true;
          this.Toast.clear();
          console.log("返回数据：", res.data)
          if(res.data.status == 100){
            this.Toast({
              duration: 2000,
              mask: true,
              message: txt + '成功'
            });
            type == 'bc' ? this.detailed.status = "保养中" : this.detailed.status = "保养完成";
            setTimeout(() => {
              this.initInfoQuery();
            }, 1000);
          }else{
            this.Toast({
              duration: 0,
              mask: true,
              message: res.data.msg
            });
          }
        },err =>{
          this.requestOnce = true;
          this.Toast.clear();
          // 提示
          this.Toast({
            mask: true,
            message: '请求超时，检查你的网络或稍后再试'
          });
          console.log(err)
        });
      }
    },
    receive(type){
      let data = Object.assign({},this.$store.state.user,{
        content: {
          vin: this.form.vin,
          type: type
        }
      });
      this.Toast({
        duration: 2000,
        mask: true,
        message: "查询中"
      });
      this.common.reqData(api.app('maintenanceGetTask'), data, res=>{
          console.log(res.data);
          if(res.data.status == 100){
            this.task = res.data.content.task || [];
            if(this.task.length == 0){
              this.isNoTask = true;
            }else{
              this.isNoTask = false;
            }
          }else{
            this.Toast({
              duration: 2000,
              mask: true,
              message: res.data.msg
            });
          }
      },err =>{
          console.log(err)
      });
    },
    initInfoQuery(){
      let data = Object.assign({},this.$store.state.user,{
        content: {
          vin: this.form.vin
        }
      });
      this.common.reqData(api.app('maintenanceGetOther'), data, res=>{
          console.log("初始化",res.data);
          if(res.data.status == 100){
            this.task = res.data.content.task || [];
            if(this.task.length == 0){
              this.isNoTask = true;
            }else{
              this.isNoTask = false;
            }
          }else{
            this.isNoTask = true;
            this.Toast({
              duration: 2000,
              mask: true,
              message: res.data.msg
            });
          }
      },err =>{
          console.log(err)
      });
    },
    changeAbnormal(val, index){
      val == "异常" ? this.expandIndex = index : this.expandIndex = -1;
    },
    rowClick(index,row,event){
      row.status == "异常" ? this.expandIndex = index : this.expandIndex = -1;
    },
    handleSortChange ({name, order}) {
      this.list = this.list.sort((a, b) => order === 'asc' ? a[name] - b[name] : b[name] - a[name]);
    },
    hideDetailed(){
      this.showDetailedDialog = false;
    },
    showDetailed(item){
      this.detailed = item;
      this.showDetailedDialog = true;
    },
    openFullscreenDialog (index) {
      this.bigImg = this.src[index];
      this.openFullscreen = true;
    },
    closeFullscreenDialog () {
      this.openFullscreen = false;
    },
    handleSortChange ({name, order}) {
      this.list = this.list.sort((a, b) => order === 'asc' ? a[name] - b[name] : b[name] - a[name]);
    },
    changeCheckBox(v){
      console.log(this.form.checkbox)
    },
    deleteImgDialog (index) {
      // 删除图片 打开
      this.deleteIndex = index;
      this.openAlert = true;
    },
    closeAlertDialog (state) {
      // 删除图片 关闭
      if(state === 'y'){
          this.src.splice(this.deleteIndex, 1);
          this.files.splice(this.deleteIndex, 1);
      }
      this.openAlert = false;
    },
    
    paizhao(){
      let _this = this;
      if(window.plus){
        var cmr = plus.camera.getCamera();
        var res = cmr.supportedImageResolutions[0];
        var fmt = cmr.supportedImageFormats[0];
        console.log("Resolution: "+res+", Format: "+fmt);
        cmr.captureImage( function( path ){
            plus.io.resolveLocalFileSystemURL( path, function ( entry ) {
                // 转化本地绝对路径
                var url = plus.io.convertLocalFileSystemURL(path);
                _this.src.push("file://"+url);
                // 获取图片对象
                entry.file( function(file){
                    var fileReader = new plus.io.FileReader();
                    fileReader.onloadend = function(evt) {
                        console.log(evt.target.result);
                        _this.files.push(evt.target.result);
                    }
                    fileReader.readAsDataURL(file);
                });
            });
        },
        function( error ) {
            console.log( "拍照已经取消: " + error.message );
        },
        {resolution:res,format:fmt}
        );
      }
    },
    getData (){
      this.initInfoQuery();
    },
    closeing (val) {
      val ? this.isScanning = false : null;
    },
    childByValue (val) {
      if(val){
        if(val.split('&')[1] == 'vin'){
          this.form.vin = val.split('&')[0];
          this.getData();
        }
      }
    },
    scan (txt) {
      this.scanMark = txt;
      this.isScanning = true;
    },
    closeFullscreenDialog(){
      this.openFullscreen = false;
      this.closeScan();
    },
    scanQR(){
      this.openFullscreen = true;
      let _this = this;
      if (!window.plus) {return;}
      setTimeout(() => {
        scan = new plus.barcode.Barcode('bcid');
        scan.onmarked = onmarked;
        function onmarked(type, result, file) {
          switch (type) {
            case plus.barcode.QR:
              type = 'QR';
              break;
            case plus.barcode.EAN13:
              type = 'EAN13';
              break;
            case plus.barcode.EAN8:
              type = 'EAN8';
              break;
            default:
              type = '其它' + type;
              break;
          }
          result = result.replace(/\n/g, '');
          _this.form.vin = result;
          _this.closeScan();
        }
      }, 40);
    },
    //开始扫描
    startScan() {
      if (!window.plus) {return;}
      scan.start();
    },
    //关闭
    closeScan() {
      this.openFullscreen = false;
      if (!window.plus) {return;}
      scan.close();
    },
  },
  mounted () {
    this.initInfoQuery();
  },
  watch: {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.auto-width{
  width: 100%;
  max-width: 375px;
  margin: 10px auto;
}
.my-null{
  color: red;
  font-size: 1.25rem;
  font-weight: bold;
  padding: 15px;
  margin-bottom: 2rem;
}
.detailed{
  padding: 15px;
  height: calc(100% - 56px);
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto; 
}
.my-card{
  margin-bottom: 2rem;
  padding: 15px;
}
.input{
  display: block;
  margin-top: 15px;
  margin-bottom: 15px;
}
#mytable .mu-input{
  width: 100%;
  margin: 0;
}
.otherMaintenance-btns{
  display: flex;
  width: 85%;
  margin-top: 20px;
  justify-content: space-between;
}
.otherMaintenance-btns button{
  margin: 0 0;
}
.photos{
    border: 1px solid #ccc;
    width: 90%;
    margin: 20px auto 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}
i.iconfont.icon-icon25201{
    display: block;
    font-size: 50px;
    margin: 10px;
}
.otherMaintenance-box{
  padding-bottom: 5px;
}
.auto-width-s.sm{
  width: 80%;
}
.project{
  width: 100%;
  height: 20px;
  text-overflow:ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.bottom-sheet-mine{
  display: flex;
  justify-content: space-around;
}
.bottom-sheet-mine > div{
  line-height: 2rem;
  background: #eee;
  padding: 0 20px;
  border-radius: 10px;
  margin: 1rem 0;
}
</style>



// WEBPACK FOOTER //
// src/components/maintenance/otherMaintenance.vue